<template>
  <div class="new-head">
    <div class="new-head-left fl" v-if="showTitle">
      <div class="system-title oneline fl">
        <img :src="logoUrl" v-if="logoUrl" alt="logo"><span style="font-style:italic">{{companyName}}</span>
      </div>
    </div>
    <div class="fl menu-fold-box" v-if="showTitle">
      <span class="menu-fold el-icon-s-unfold pointer"
            v-show="isCollapse"
            @click="toggleMenu"></span>
      <span class="menu-fold el-icon-s-fold pointer"
            v-show="!isCollapse"
            @click="toggleMenu"></span>
    </div>
    <div class="fl menu-tabs">
      <!-- <el-tabs v-model="currentRoute.name" type="card" closable @tab-remove="removeTab">
        <el-tab-pane
          v-for="(item, key) in routeList"
          :key="key"
          :label="item.title"
          :name="item.name"
        ></el-tab-pane>
      </el-tabs> -->
      <TagsRoute />
    </div>
    <div class="fr">
      <ul>
        <li class="li-alarm"
            @click="goPage">
          <el-tooltip class="item"
                      effect="dark"
                      content="报警信息"
                      placement="bottom">
            <span class="el-icon-message-solid waitDeal">
              <i class="count"></i>
            </span>
          </el-tooltip>
        </li>
        <li class="li-screen" v-if="judgeAuth('screen')"
            @click="goPageScreen">
          <el-tooltip class="item"
                      effect="dark"
                      content="可视化平台"
                      placement="bottom">
            <span class="el-icon-monitor waitDeal">
            </span>
          </el-tooltip>
        </li>
        <li class="li-user">
          <el-avatar size="small" :src="circleUrl"></el-avatar>
           <el-tooltip class="item"
                      effect="dark"
                      :content="userInfo.nickName"
                      placement="bottom">
            <span class="nickName oneline">{{userInfo.nickName}}</span>
           </el-tooltip>
        </li>
        <li class="li-screen">
          <el-tooltip class="item"
                      effect="dark"
                      content="退出系统"
                      placement="bottom">
            <span @click="handleLogout"
                  class="icon-screen-close"></span>
          </el-tooltip>
        </li>
        <li class="li-logout"
            v-if="false">
          <el-dropdown size="small"
                       @command="handleCommand">
            <span class="el-dropdown-link">
              <el-avatar size="small"
                         :src="circleUrl"></el-avatar>
              {{userName}}
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="1">退出</el-dropdown-item>
              <el-dropdown-item :command="2">修改密码</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </li>
      </ul>
    </div>
    <!-- <update-pwd :dialogVis="dialogVis" @close-dialog="closeDialog"/> -->
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import TagsRoute from './TagsRoute'
import { baseUrl } from '@/config/env'
import { getSystemDetail } from '@/api/config'
import {
  getUserInfo,
  doLogout // 退出
} from '@/api/login'
export default {
  components: { TagsRoute },
  data () {
    return {
      input1: '',
      companyName: '',
      defaultName: '智慧用电安全监控系统',
      logoUrl: '',
      defaultLogo: require('@/assets/images/screen/copy.png'),
      circleUrl: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
      routeOption: [],
      routeOption1: [],
      linkUrl: '',
      unData: 0,
      dialogVis: false,
      userName: '',
      systemInfo: {},
      showTitle: true
    }
  },
  computed: {
    routes () {
      return this.$store.getters.routers
    },
    companyId () {
      return this.$store.getters.projectId
    },
    companyInfo () {
      return this.$store.getters.projectInfo
    },
    userInfo () {
      return this.$store.getters.userInfo
    },
    refreshLogo () {
      return this.$store.getters.refreshLogo
    },
    // 消息通知 推送
    hiddenRefresh () {
      return this.$store.getters.hiddenRefresh
    },
    permissionList () {
      return this.$store.getters.permissionList
    },
    // 消息通知 推送
    alarmRefresh () {
      return this.$store.getters.alarmRefresh
    },
    isCollapse () {
      return this.$store.getters.isCollapse
    }
  },
  watch: {
    // 消息通知 推送 待办刷新
    hiddenRefresh: {
      handler (newVal, oldVal) {
        if (newVal) {
          this.backLogCount()
        }
      },
      deep: true
    },
    userInfo: {
      handler (newVal, oldVal) {
        if (newVal) {
          // this.systemInfo = newVal
        }
      },
      deep: true
    },
    companyInfo: {
      handler (newVal, oldVal) {
        if (newVal) {
          this.logoUrl = newVal.logo || this.defaultLogo
          this.companyName = newVal.showName || this.defaultName
        }
      },
      deep: true
    },
    // 推送 信息刷新
    alarmRefresh (n, o) {
      if (n) {
        this.backLogCount()
      }
    },
    refreshLogo: {
      handler (n, o) {
        // console.log(n)
        // this.logoUrl = n.logo ? n.logo.indexOf('http') < 0 ? (baseUrl + n.logo) : n.logo : ''
        // this.companyName = n.nickName ? n.nickName : this.companyInfo.companyName + '安全监管系统'
      },
      deep: true
    },
    linkUrl: {
      handler (n, o) {
        if (n) {
          this.$router.push({ path: n })
        }
      },
      deep: true
    }
  },
  created () {
    let type = this.getUrlParam('type')
    this.showTitle = !type
    let systemInfo = sessionStorage.getItem('userInfo')
    if (systemInfo) {
      this.systemInfo = JSON.parse(systemInfo)
    }
    this.getUserInfo()
    this.getSystemInfo()
  },
  methods: {
    getUrlParam (name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)') // 构造一个含有目标参数的正则表达式对象
      var r = window.location.search.substr(1).match(reg) // 匹配目标参数
      if (r != null) return unescape(decodeURI(r[2]))
      return null // 返回参数值
    },
    judgeAuth (role) {
      let flag = this.permissionList.some(item => item === role)
      return flag
    },
    async getUserInfo () {
      let res = await getUserInfo()
      if (res.code === '000000') {
        // console.log('456=', res)
        let data = res.data
        this.systemInfo.nickName = data.nickName || data.account || ''
        this.systemInfo.userType = data.userType || '' // 1企业  2集团 3供电所 4监管单位
        this.systemInfo.projectId = data.projectId || ''
        this.systemInfo.userId = data.userId || ''
        // console.log(this.systemInfo)

        this.$store.dispatch('setUserInfo', this.systemInfo)
        this.$store.dispatch('setUserId', this.systemInfo.userId)
        this.$store.dispatch('setIsProjectUser', this.systemInfo.userType == 1 || this.systemInfo.userType == 5)
        if (this.systemInfo.userType == 1) {
          this.$store.dispatch('setProjectId', this.systemInfo.projectId)
        }
      }
    },
    // 获取系统信息
    async getSystemInfo () {
      let resData = await getSystemDetail()
      if (resData) {
        this.$store.dispatch('setProjectInfo', resData)
      }
    },
    toggleMenu () {
      let isCollapse = this.isCollapse
      this.$store.dispatch('setIsCollapse', !isCollapse)
    },
    closeDialog () {
      this.dialogVis = false
    },
    selectBlur () {
      if (this.routeOption.length === 0) {
        setTimeout(() => {
          this.routeOption = this.routeOption1
        }, 100)
      }
    },
    initRoute (route) {
      route.forEach(item => {
        if (!item.hidden) {
          if (!item.children) {
            this.routeOption1.push(item)
            this.routeOption.push(item)
          } else {
            item.children.forEach(val => {
              if (item.path.indexOf('/') > -1) {
                val.parentPath = item.path
              } else {
                val.parentPath = item.parentPath + '/' + item.path
              }
            })
            this.initRoute(item.children)
          }
        }
      })
    },
    remoteMethod (query) {
      if (query !== '') {
        let PinyinMatch = this.$pinyinmatch
        this.routeOption = this.routeOption1.filter(item => {
          return item.meta.title.toLowerCase()
            .indexOf(query.toLowerCase()) > -1 || PinyinMatch.match(item.meta.title, query)
        })
      } else {
        this.routeOption = this.routeOption1
      }
      console.log(this.routeOptio)
    },
    handleCommand (command) {
      switch (command) {
        case 1:
          this.handleLogout()
          break
        case 2:
          this.updatePassBtn()
          break
        default:
          break
      }
    },
    updatePassBtn () {
      this.dialogVis = true
    },
    // backLogCount () {
    //   backLogCount({
    //     companyId: this.companyId
    //   })
    //     .then(res => {
    //       if (res.success) {
    //         this.unData = res.data
    //       } else {
    //         this.$message({
    //           message: res.msg,
    //           type: 'error'
    //         })
    //       }
    //     })
    //     .catch(err => {
    //       console.log(err)
    //     })
    // },
    // // 获取企业信息
    // getCompanyInfo (companyId) {
    //   getConfigInfo({
    //     companyId: companyId
    //   })
    //     .then(res => {
    //       if (res.code === '000000') {
    //         this.refreshLogo.logo = res.data.logo
    //         this.refreshLogo.nickName = res.data.nickName
    //         sessionStorage.setItem('companyConfig', JSON.stringify(this.refreshLogo))
    //         this.$store.dispatch('setRefreshLogo', this.refreshLogo)
    //       } else {
    //         this.$message({
    //           message: res.message,
    //           type: 'error',
    //           duration: 5 * 1000
    //         })
    //       }
    //     }).catch(err => {
    //       console.log(err)
    //     })
    // },
    // 通过token获取user信息
    // getUserInfoByToken () {
    //   getUserInfoByToken()
    //     .then(res => {
    //       if (res.code === '000000') {
    //         this.companyInfo.id = res.data.userId || ''
    //         this.companyInfo.account = res.data.account || ''
    //         this.companyInfo.name = res.data.name || ''
    //         this.userName = res.data.name

    //         let companyId = res.data.companyId
    //         if (companyId) {
    //           sessionStorage.setItem('projectId', companyId)
    //           this.$store.dispatch('setProjectId', companyId)
    //           this.getCompanyInfo(companyId)
    //         }
    //         this.$store.dispatch('setProjectInfo', this.companyInfo)
    //       } else {
    //         this.$message({
    //           message: res.message,
    //           type: 'error',
    //           duration: 5 * 1000
    //         })
    //       }
    //     }).catch(err => {
    //       console.log(err)
    //     })
    // },
    goPage () {
      this.$router.push({
        name: 'hiddenSearch'
      })
    },
    goPageScreen () {
      let routeInfo = this.$router.resolve({
        name: 'screen'
      })
      window.open(routeInfo.href, '_blank')
      // this.$router.push({
      //   name: 'screen'
      // })
    },
    handleLogout () {
      this.$confirm('此操作将退出登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // this.logoutEvent()
        this.getLogout()
      }).catch(() => {
      })
    },
    logoutEvent () {
      Cookies.remove('satoken')
      sessionStorage.removeItem('projectId')
      sessionStorage.removeItem('projectInfo')
      sessionStorage.removeItem('userInfo')
      sessionStorage.removeItem('route')
      sessionStorage.removeItem('auth')
      if (this.showTitle) {
        window.location.href = window.location.protocol + '//' + window.location.host
      } else {
        window.location.href = window.location.protocol + '//' + window.location.host + '/index.html?type=1#/'
      }
    },
    getLogout () {
      doLogout({
      }).then(response => {
        if (response.code === '000000') {
          this.logoutEvent()
        } else {
          this.$message({
            message: response.message,
            type: 'error',
            duration: 5 * 1000
          })
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/element-variables.scss";
.new-head {
  position: fixed;
  height: 60px;
  background-image: linear-gradient(90deg, #5a5efd 0%, #3377ff 100%);
  box-shadow: 0px 2px 30px 0px rgba(60, 60, 67, 0.2);
  top: 0;
  left: 0;
  width: 100%;
  // box-shadow: 0px 3px 7px 0px rgba(204, 204, 204, 0.06);
  line-height: 60px;
  padding: 0 20px;
  z-index: 1002;
  color: #fff;
  padding-left: 10px;
  .new-head-left {
    line-height: 60px;
    height: 60px;
    font-size: 18px;
    width: 250px;
    img {
      width: 24px;
      height: 24px;
      // width: auto;
      // height: 100%;
      // border: 1px solid #fff;
      position: relative;
      top: 6px;
      margin-right: 6px;
      border-radius: 50%;
      // background-color: #fff;
    }
  }
  .menu-fold-box {
  }
  .menu-fold {
    font-size: 24px;
    position: relative;
    top: 4px;
  }
  .fr {
    ul {
      li {
        display: inline-block;
        vertical-align: top;
        margin: 0 15px;
        position: relative;
        cursor: pointer;
        line-height: 60px;
        // &::before {
        //   content: "";
        //   position: absolute;
        //   top: 14px;
        //   left: -23px;
        //   width: 1px;
        //   height: 20px;
        //   background-color: rgba(255, 255, 255, 0.2);
        // }
        &:nth-of-type(1) {
          &::before {
            display: none;
          }
        }
        &:last-of-type {
          margin-right: 0;
        }
      }
    }
  }
}
.head-input {
  /deep/ .el-input {
    .el-input__inner {
      width: 200px;
      height: 28px;
      // background-color: #e3ebc4;
      color: #999;
    }
    .el-input__suffix {
      .el-icon-search {
        color: #749110;
      }
    }
  }
  .search-list {
    min-width: 150px !important;
    li.el-select-dropdown__item {
      width: 100%;
      line-height: 34px;
      margin: 0;
      display: block;
    }
  }
}
.icon-screen-close {
  display: inline-block;
  width: 28px;
  height: 28px;
  background-image: url(~@/assets/images/close.png);
  background-size: 100%;
  position: relative;
  top: 10px;
}
.li-alarm {
  line-height: 48px;
  text-align: center;
  .el-icon-message-solid {
    font-size: 20px;
  }
  .count {
    position: absolute;
    top: 15px;
    right: -4px;
    font-size: 10px;
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: rgba(255, 0, 0, 1);
  }
}
.li-screen {
  .waitDeal {
    font-size: 20px;
  }
}
.li-user {
  .el-avatar {
    vertical-align: middle;
  }
  .nickName{
    display: inline-block;
    max-width: 80px;
    vertical-align: top;
    line-height: 22px;
    margin-top: 20px;
  }
}
.el-dropdown-link {
  color: #fff;
  .el-avatar {
    position: relative;
    top: 8px;
    margin-right: 4px;
  }
}
.li-logout {
  .el-dropdown {
    height: 30px;
  }
}

.menu-tabs {
  height: 100%;
  width: calc(100% - 600px);
  margin-left: 20px;
  /deep/ .el-tabs {
    height: 100%;
    .el-tabs__header {
      margin-bottom: 0;
      border: none;
    }
    .el-tabs__nav {
      border: none;
    }
    .el-tabs__nav-next,
    .el-tabs__nav-prev {
      line-height: 60px;
      color: #fff;
      font-size: 20px;
    }
    .el-tabs__item {
      color: rgba(255, 255, 255, 0.5);
      border: none;
      position: relative;
      font-size: 14px;
      &::before {
        content: "";
        position: absolute;
        width: 1px;
        height: 20px;
        background-color: rgba(255, 255, 255, 0.5);
        left: 0;
        top: 10px;
      }
      &:first-of-type {
        &::before {
          display: none;
        }
      }
      .el-icon-close {
        &:hover {
          background-color: #fff;
          color: #343434;
        }
      }
    }
    .el-tabs__item.is-active {
      font-size: 16px;
      font-weight: bold;
      color: #fff;
    }
  }
}
</style>
